import { render, staticRenderFns } from "./EventSelector.vue?vue&type=template&id=55c54673&scoped=true"
import script from "./EventSelector.vue?vue&type=script&lang=js"
export * from "./EventSelector.vue?vue&type=script&lang=js"
import style0 from "./EventSelector.vue?vue&type=style&index=0&id=55c54673&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c54673",
  null
  
)

export default component.exports